import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnInit } from '@angular/core';
import { AngularFireStorage } from 'angularfire2/storage';
import { Observable } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'download-img',
  template: `<div *ngIf="canShow"><img #img class="img" [src]="profileUrl | async" width="{{width}}" height="{{height}}"/></div>`
})
export class DownloadImgComponent implements OnInit {
  
  fileName: string;
  loaded: boolean;
  imgSrc: string;
  FSrc: string;
  fDataPath: string;
  canShow: boolean = false;

  @ViewChild('img') img: ElementRef<HTMLImageElement>;

  @Input()
  days=1;
  @Input()
  height = 90;
  @Input()
  width = 90;

  @Input()
  set src(x: string) {
    if (x) {
      this.FSrc = x;
      if (!this.fDataPath)
        this.download(x);
    }
  }
  get src() {
    return this.FSrc;
  }


  @Input()
  set dataPath(x) {
    this.fDataPath = x;
    this.canShow = (x?true:false);
    if (this.loaded)
    if (!this.carregarLocal(x))
      this.load(x);
  }
  get dataPath() {
    return this.fDataPath;
  }

  // carrega dados do servidor
  load(x) {
    if (x && this.loaded) {
      this.fileName = x;
      this.db.collection("imagens").doc(x).ref.get()
        .then(doc => {
          if (doc.exists) {
            let d = doc.data();
            this.img.nativeElement.src = d.src;
            this.imgSrc = d.src;
            this.salvarLocal(d.src);
          }
        });
    }
  }

  // salva no local
  salvarLocal(base64) {
    let d = new Date();
    d.setDate(d.getDate() + this.days)
    let b = {src:base64, expiration: d } 
    window.localStorage.setItem(this.fileName, JSON.stringify(b));
  }

 // carrega do local
  carregarLocal(fn){
    let b;
    try {
      b = JSON.parse(window.localStorage.getItem(fn));
    } catch(e){
      return false;
    }
    if (!b)
       return false;
    let d = b.expiration;
    if (d< new Date()) return false;
    this.imgSrc = b.src;   
    if (this.imgSrc && this.img){
      this.img.nativeElement.src = this.imgSrc;
      //console.log("Imagem Local:",fn);
    }
    return (this.imgSrc!==null)
  }

  ngOnInit() {
  }

  ngAfterViewInit(){
    this.loaded = true;
    if (!this.carregarLocal(this.fDataPath))
       this.load(this.fDataPath);

  }

  profileUrl: Observable<string | null>;

  constructor(private db: AngularFirestore, private storage: AngularFireStorage) {
  }


  // carrega do storage
  download(x: string) {
    if ((x > '') && (!this.imgSrc)) {
      try {
        const ref = this.storage.ref(x);
        this.profileUrl = ref.getDownloadURL();
        this.profileUrl.subscribe(
          f => {
            this.canShow = true;
            //console.log('Imagem Storage');
          }
        )
      } catch (err) {
        console.log(err.message);
      }
    }
  }
}